import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { AttachmentViewerProps } from './AttachmentViewer.types';
import { AttachmentViewerContainer } from './AttachmentViewerContainer';
import { AttachmentViewerSkeleton } from './AttachmentViewerSkeleton';

export const LazyCarouselAttachmentViewer: FunctionComponent<
  AttachmentViewerProps
> = ({ onClose, attachmentId, cardId }) => {
  const CarouselAttachmentViewer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "carousel-attachment-viewer" */ './CarouselAttachmentViewer'
      ),
    { namedImport: 'CarouselAttachmentViewer', preload: false },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Carousel Attachment Viewer',
      }}
    >
      <AttachmentViewerContainer onClose={onClose}>
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={<AttachmentViewerSkeleton />}>
            <CarouselAttachmentViewer
              onClose={onClose}
              attachmentId={attachmentId}
              cardId={cardId}
            />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </AttachmentViewerContainer>
    </ErrorBoundary>
  );
};
